export default "__VITE_ASSET__BqsyIB67__"